<script setup lang="ts">
  import { CardItem } from "@src/components";

  const { itemId } = defineProps<{ itemId: string }>();
  const emit = defineEmits<{ (e: "close"): void; (e: "back"): void }>();
</script>

<template>
  <CardItem :itemId="itemId" @close="emit('close')" @back="emit('back')" />
</template>
